import { envFn } from "@platform/env"
import { Logger } from "../../utils/logger"
export class EnvMap {
  private _Map: { [key: string]: any } = {}
  init(map: object) {
    if (Object.prototype.toString.call(map) !== "[object Object]") {
      throw Error("type is not an object")
    }
    this._Map = Object.assign({}, map)
  }

  set(key: string, value: unknown) {
    const _env = envFn?.getEnv?.()
    this._Map[_env][key] = value
  }

  get(key: string) {
    const _env = envFn?.getEnv?.()
    if (!_env) {
      Logger.warn(`uninitialized env: ${_env}`)
      return undefined
    }
    if (!Object.keys(this._Map)?.length) {
      Logger.warn("uninitialized envMapper")
      return undefined
    }
    if (!this._Map.hasOwnProperty(_env)) {
      Logger.warn(`could not find ${_env} from envMapper`)
      return undefined
    }
    const map = this._Map[_env]
    if (!map.hasOwnProperty(key)) {
      Logger.warn(`could not find ${key} from varMapper: ${Object.keys(map)}`)
      return undefined
    }
    const result = map?.[key]
    try {
      return typeof result === "string" ? JSON.parse(result) : result
    } catch (e) {
      Logger.error("getEnv Error", result, e)
    }
  }

  delete(key: string) {
    const _env = envFn?.getEnv?.()

    return delete this._Map?.[_env]?.[key]
      ? true
      : `could not find ${key} from ${_env} mapper`
  }

  keys(env?: string) {
    if (env) {
      if (!(env in this._Map)) {
        Logger.warn(`could not find ${env} from envMapper`)
        return undefined
      }
      return Object.keys(this._Map[env])
    }
    return Object.keys(this._Map)
  }

  getMap() {
    return this._Map
  }
}
